import { useEffect, useState, createContext } from "react";
import { allBrands } from "../utilities/services";


const BrandsContext = createContext()

const BrandsProvider = ({children}) => {
    const [dataBrands, setDataBrands] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const brands = await allBrands();
            setDataBrands(brands);
        }
        fetchData();
    }, [])
    
    return (
        <BrandsContext.Provider
            value={{
                dataBrands
            }}
        >
            {children}
        </BrandsContext.Provider>
    )
}

export {
    BrandsProvider
}

export default BrandsContext